import { render, staticRenderFns } from "./DetalheHistorico.vue?vue&type=template&id=6c26acea"
import script from "./DetalheHistorico.vue?vue&type=script&lang=js"
export * from "./DetalheHistorico.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports